import dayjs from 'dayjs';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';

const URL = process.env.REACT_APP_API_ENDPOINT;

const STATUS = process.env.REACT_APP_STATUS;
console.log(STATUS);

const WhatsappApiFunctions = {
  getTempleList: async (filter, StoreId) => {
    const accessToken = localStorage.getItem('accessToken');
    // const formdata = new FormData();
    // formdata.append('EventTypeKey', 24000001);

    const requestOptions = {
      method: 'POST',
      // body: formdata,
      redirect: 'follow',
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    };

    try {
      const url = `${URL}Template/ListTemplate`;
      const response = await fetch(url, requestOptions);
      const data = await response.json();
      if (response.status === 404 || response.status === 403) {
        console.warn('Access forbidden: 404');
        localStorage.setItem('adminAuthenticated', false);
        window.location.href = '/login';
        return null; // 👈 fixes ESLint error
      }
      return data;
    } catch (error) {
      console.error('Error fetching user counts:', error);
      throw new Error('Failed to fetch user counts');
    }
  },
  getEventList: async (templateKey) => {
    const accessToken = localStorage.getItem('accessToken');
    const formdata = new FormData();
    formdata.append('TemplateKey', templateKey);
    const requestOptions = {
      method: 'POST',
      body: formdata,
      redirect: 'follow',
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    };

    try {
      const url = `${URL}Template/ListEvent`;
      const response = await fetch(url, requestOptions);
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching user counts:', error);
      throw new Error('Failed to fetch user counts');
    }
  },
  getStatusList: async (filter, StoreId) => {
    const accessToken = localStorage.getItem('accessToken');
    const formdata = new FormData();
    // formdata.append('EventTypeKey', 24000001);
    const requestOptions = {
      method: 'POST',
      body: formdata,
      redirect: 'follow',
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    };

    try {
      const url = `${URL}Message/ListMessageStatus`;
      const response = await fetch(url, requestOptions);
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching user counts:', error);
      throw new Error('Failed to fetch user counts');
    }
  },
  singleTestNumber: async (eventKey, userParamData) => {
    const accessToken = localStorage.getItem('accessToken');
    const formdata = new FormData();
    formdata.append('EventKey', eventKey);
    formdata.append('UserParamData', JSON.stringify(userParamData));

    const requestOptions = {
      method: 'POST',
      body: formdata,
      redirect: 'follow',
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    };

    try {
      const url = `${URL}Message/SendTestMsg`;
      const response = await fetch(url, requestOptions);
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching user counts:', error);
      throw new Error('Failed to fetch user counts');
    }
  },
  getAnalyticsCount: async (filter) => {
    const accessToken = localStorage.getItem('accessToken');

    console.log('filter', filter);
    const formdata = new FormData();
    formdata.append('number', filter.number || '');
    // Pass template as `templateKey` per latest requirement
    formdata.append('templateKey', filter.template || '');
    formdata.append('MessageStates', filter.status?.MessageStatusKey || '');
    formdata.append('FromDate', dayjs(filter.date.fromDate, 'DD-MM-YYYY').format('YYYY-MM-DD'));
    formdata.append('ToDate', dayjs(filter.date.toDate, 'DD-MM-YYYY').format('YYYY-MM-DD'));

    const requestOptions = {
      method: 'POST',
      body: formdata,
      redirect: 'follow',
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    };

    try {
      const url = `${URL}Message/ListMessage`;
      const response = await fetch(url, requestOptions);

      if (response.status === 403) {
        console.warn('Access forbidden: 403');
        localStorage.setItem('adminAuthenticated', false);
        toast.success('Login');

        window.location.href = '/login';
        return null; // 👈 fixes ESLint error
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching user counts:', error);
      throw new Error('Failed to fetch user counts');
    }
  },

  getMsgContent: async (templateKey) => {
    const accessToken = localStorage.getItem('accessToken');
    const formdata = new FormData();
    formdata.append('TemplateKey', templateKey || '');
    const requestOptions = {
      method: 'POST',
      body: formdata,
      redirect: 'follow',
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    };

    try {
      const url = `https://api-whatsapp.coitor.com/Message/GetMsgContent`;
      const response = await fetch(url, requestOptions);
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching user counts:', error);
      throw new Error('Failed to fetch user counts');
    }
  },
  testNumber: async (Number, TemplateKey) => {
    const accessToken = localStorage.getItem('accessToken');
    const formdata = new FormData();
    formdata.append('Number', Number);
    formdata.append('TemplateKey', TemplateKey);
    const requestOptions = {
      method: 'POST',
      body: formdata,
      redirect: 'follow',
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    };

    try {
      const url = `${URL}Message/SendTestMsg`;
      const response = await fetch(url, requestOptions);
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching user counts:', error);
      throw new Error('Failed to fetch user counts');
    }
  },

  sendBulkMsg: async (file, EventKey, columnRef, sheetName) => {
    const accessToken = localStorage.getItem('accessToken');

    const formdata = new FormData();
    formdata.append('file', file);
    formdata.append('EventKey', EventKey);
    formdata.append('ColumnRef', columnRef);
    formdata.append('sheet_name', sheetName);

    const requestOptions = {
      method: 'POST',
      body: formdata,
      redirect: 'follow',
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    };

    try {
      const url = `${URL}Message/SendBulkMsg`;
      const response = await fetch(url, requestOptions);
      const data = await response.json();
      return { data, response };
    } catch (error) {
      console.error('Error fetching user counts:', error);
      throw new Error('Failed to fetch user counts');
    }
  },

  getMessageDownloadReport: async (filter, page, size) => {
    const accessToken = localStorage.getItem('accessToken');
    const formdata = new FormData();
    formdata.append('number', filter.number || '');
    formdata.append('TemplateKey', filter.template.MessageTemplateKey || '');
    formdata.append('MessageStates', filter.status.MessageStatusKey || '');
    formdata.append('Page', page || '');
    formdata.append('Size', size || '');
    formdata.append('FromDate', dayjs(filter.date.fromDate, 'DD-MM-YYYY').format('YYYY-MM-DD'));
    formdata.append('ToDate', dayjs(filter.date.toDate, 'DD-MM-YYYY').format('YYYY-MM-DD'));

    const requestOptions = {
      method: 'POST',
      body: formdata,
      redirect: 'follow',
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    };

    try {
      const url = `${URL}Message/ListMessage`;
      const response = await fetch(url, requestOptions);
      const data = await response.json();
      console.log(data);
      return data;
    } catch (error) {
      console.error('Error fetching user counts:', error);
      throw new Error('Failed to fetch user counts');
    }
  },

  // Explicit ListMessage API wrapper (paginated)
  getListMessage: async (filter, page, size) => {
    const accessToken = localStorage.getItem('accessToken');
    const formdata = new FormData();
    formdata.append('number', filter.number || '');
    formdata.append('TemplateKey', filter.template || '');
    formdata.append('MessageStates', filter.status?.MessageStatusKey || '');
    formdata.append('Page', page || '');
    formdata.append('Size', size || '');
    formdata.append('FromDate', dayjs(filter.date.fromDate, 'DD-MM-YYYY').format('YYYY-MM-DD'));
    formdata.append('ToDate', dayjs(filter.date.toDate, 'DD-MM-YYYY').format('YYYY-MM-DD'));

    const requestOptions = {
      method: 'POST',
      body: formdata,
      redirect: 'follow',
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    };

    try {
      const url = `${URL}Message/ListMessage`;
      const response = await fetch(url, requestOptions);
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching ListMessage:', error);
      throw new Error('Failed to fetch ListMessage');
    }
  },

  getMessageDownloadReport2: async (filter, storeId) => {
    const accessToken = localStorage.getItem('accessToken');
    const formdata = new FormData();
    // Accept both template object and direct key value
    formdata.append('TemplateKey', (filter.template && filter.template.MessageTemplateKey) || filter.template || '');

    // formdata.append('Page', '');
    formdata.append('FromDate', dayjs(filter.date.fromDate, 'DD-MM-YYYY').format('YYYY-MM-DD'));
    formdata.append('ToDate', dayjs(filter.date.toDate, 'DD-MM-YYYY').format('YYYY-MM-DD'));

    const requestOptions = {
      method: 'POST',
      body: formdata,
      redirect: 'follow',
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    };

    try {
      const url = `${URL}Message/DownloadReport`;
      const response = await fetch(url, requestOptions);
      const data = await response.json();
      console.log(data);
      return data;
    } catch (error) {
      console.error('Error fetching user counts:', error);
      throw new Error('Failed to fetch user counts');
    }
  },
};

export default WhatsappApiFunctions;
